export default "__VITE_ASSET__6475a388__"